export type MobileOS = 'ios' | 'android';

/**
 * Detects the mobile OS from a browser user agent string.
 * Returns `null` for desktop browsers or unrecognized user agents.
 */
export function getMobileOS(userAgent: string = navigator.userAgent): MobileOS | null {
	if (/android/i.test(userAgent)) return 'android';
	if (/iphone|ipad|ipod/i.test(userAgent)) return 'ios';
	return null;
}
